import { useEffect } from 'react';
import Hls from 'hls.js';
import { usePlaybackContext } from "../../Playback";
/**
 * This hook is used to listen to the LEVEL_LOADED event fired by hls.js,
 * needed to validate the loading state.
 *
 * LEVEL_LOADED: fired when a level playlist loading finishes. Reference: https://github.com/video-dev/hls.js/blob/master/docs/API.md#runtime-events
 */
var useLevelLoadedEvent = function useLevelLoadedEvent(_ref) {
  var hls = _ref.hls;
  var _usePlaybackContext = usePlaybackContext(),
    onLoadedData = _usePlaybackContext.onLoadedData;
  useEffect(function () {
    if (!hls) {
      return;
    }
    hls.on(Hls.Events.LEVEL_LOADED, onLoadedData);
    return function () {
      if (!hls) {
        return;
      }
      hls.off(Hls.Events.LEVEL_LOADED, onLoadedData);
    };
  }, [hls, onLoadedData]);
};
export default useLevelLoadedEvent;